/// <reference path="../../_Ext/Editors/BOMGridEditor.ts" />
namespace TabAurous.ECommerce {
    import fld = ECommExchangeBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ECommExchangeBOMEditor extends _Ext.BOMGridEditor<ECommExchangeBOMRow> { 
        protected getDialogType() { return ECommExchangeBOMDialog; }
        protected getLocalTextPrefix() { return ECommExchangeBOMRow.localTextPrefix; } 

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ECommExchangeItemsDialog).CalculateTotals();
                }
            });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }
         

        protected getButtons() {
            let buttons = super.getButtons();
            buttons.pop();
            var grid = OMS.RawMaterialMasterSelectGrid;
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length); 
                        var self = this; 
                        //alert(selectedItems2.length);
                        selectedItems2.forEach(function (value: OMS.RawMaterialMasterRow) {
                            var oldbom = value;


                          

                            var details = [];
                            var bom: ECommExchangeBOMRow = {
                                ProductCode: oldbom.ProductCode,
                                BOMProductId: oldbom.ProductId,
                                BOMAttributeId: oldbom.AttributeId,
                                CalcOnId: oldbom.CalcOnId,
                                Pieces: oldbom.Pieces,
                                Weight: oldbom.Weight,
                                ItemType: oldbom.ItemType,
                                ItemTypeId: oldbom.ItemTypeId,
                                StoneColorId: oldbom.StoneColorId,
                                Attribute: oldbom.Attribute,
                                CategoryId: oldbom.CategoryId,
                                SubCategoryId: oldbom.SubCategoryId,
                                ProductTypeId: oldbom.ProductTypeId,
                                QualityId: oldbom.QualityId,
                                SieveId: oldbom.SieveId,
                                ShapeId: oldbom.ShapeId,
                                StoneSizeId: oldbom.StoneSizeId,
                                SettingId: oldbom.SettingId,
                                StoneCuletId: oldbom.StoneCuletId,
                                StoneCutId: oldbom.StoneCutId,
                                StoneFluorescenceId: oldbom.StoneFluorescenceId,
                                StoneGirdleId: oldbom.StoneGirdleId,
                                StonePolishId: oldbom.StonePolishId,
                                StoneSymmetryId: oldbom.StoneSymmetryId,
                                StoneDepth: oldbom.StoneDepth,
                                StoneTable: oldbom.StoneTable,

                                KaratId: oldbom.KaratId,
                                MetalColorId: oldbom.MetalColorId,
                                Purity: oldbom.Purity,
                                PureWeight: oldbom.Purity * oldbom.Weight,
                            };

                            details.push(bom);


                            for (let Detail of details) {
                                Detail[self.getIdProperty()] = "`" + self.nextId++;
                                self.view.addItem(Detail);
                            }
                        });

                    }

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        } 

    }
}